import { CSS } from "../../constants/css";

const instance = ($modalTrigger: HTMLElement, root: Document | ShadowRoot) => {
  const id = $modalTrigger.getAttribute("data-id");
  const $modal
    = root.querySelector<HTMLElement>(`#${id}`)
      || document.querySelector<HTMLElement>(`#${id}`);

  if (!id || !$modal) {
    return;
  }

  const isRemoveScrollbars
    = $modal.getAttribute("data-remove-scrollbars") === "true";
  const $modalClose = $modal.querySelectorAll<HTMLElement>(".js-close-modal");
  const $modalOverlay = $modal.querySelector<HTMLElement>(".js-modal-overlay");
  const $modalEl = $modal.querySelector<HTMLElement>(".js-modal");

  const checkEscapeKeyToDismiss = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      hide();
    }
  };

  const hide = () => {
    $modal.classList.remove(CSS.visible);
    $modal.remove();
    document.body.appendChild($modal);

    if (isRemoveScrollbars) {
      document.documentElement.classList.remove(CSS.overflowHidden);
    }

    window.removeEventListener("keyup", checkEscapeKeyToDismiss);
  };

  const show = () => {
    $modal.classList.add(CSS.visible);

    if (isRemoveScrollbars) {
      document.documentElement.classList.add(CSS.overflowHidden);
    }

    window.addEventListener("keyup", checkEscapeKeyToDismiss);

    $modalOverlay?.addEventListener("click", hide);

    $modalEl?.addEventListener("click", (e) => {
      e.stopPropagation();
    });

    $modalClose?.forEach(($element) => {
      $element.addEventListener("click", hide);
    });
  };

  document.body.appendChild($modal);

  $modalTrigger.addEventListener("click", (event) => {
    event.preventDefault();
    show();
  });
};

export default (root: Document | ShadowRoot = document) => {
  root
    .querySelectorAll<HTMLElement>(".js-modal-trigger")
    .forEach(($modalTrigger) => {
      instance($modalTrigger, root);
    });
};
